import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Phone, Menu, X } from "lucide-react";
import { BUSINESS } from "@/data/site";

const LINKS = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/gallery", label: "Gallery" },
  { to: "/about", label: "About" },
  { to: "/blog", label: "Blog" },
  { to: "/contact", label: "Free Quote" },
];

const Header = () => {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="site-header"
      className="fixed top-0 left-0 right-0 z-50 bg-white border-b border-zinc-200"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <Link to="/" data-testid="header-logo" className="group">
          <img
            src="/images/logo-dark.png"
            alt="Amiri Roofing — Winnipeg"
            className="h-7 w-auto transition-opacity duration-300 group-hover:opacity-60"
          />
        </Link>

        <nav className="hidden lg:flex items-center gap-8" data-testid="header-nav">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase().replace(" ", "-")}`}
              className={({ isActive }) =>
                `text-xs uppercase tracking-[0.2em] font-bold transition-colors duration-300 hover:text-accent ${
                  isActive ? "text-accent" : "text-zinc-500"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <a
            href={BUSINESS.phoneHref}
            data-testid="header-call-button"
            className="flex items-center gap-2 bg-accent text-white text-xs font-bold uppercase tracking-[0.15em] px-5 py-3 transition-colors duration-300 hover:bg-zinc-900"
          >
            <Phone size={14} strokeWidth={2.5} />
            {BUSINESS.phone}
          </a>
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen(!open)}
          className="lg:hidden text-zinc-900 p-2"
          aria-label="Toggle menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.nav
            data-testid="mobile-nav"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.4, ease: [0.76, 0, 0.24, 1] }}
            className="lg:hidden overflow-hidden border-t border-zinc-200 bg-white/95 backdrop-blur-xl"
          >
            <div className="px-6 py-6 flex flex-col gap-5">
              {LINKS.map((l) => (
                <NavLink
                  key={l.to}
                  to={l.to}
                  onClick={() => setOpen(false)}
                  data-testid={`mobile-nav-${l.label.toLowerCase().replace(" ", "-")}`}
                  className={({ isActive }) =>
                    `text-sm uppercase tracking-[0.2em] font-bold ${
                      isActive ? "text-accent" : "text-zinc-600"
                    }`
                  }
                >
                  {l.label}
                </NavLink>
              ))}
              <a
                href={BUSINESS.phoneHref}
                data-testid="mobile-call-button"
                className="flex items-center gap-2 text-accent text-sm font-bold uppercase tracking-[0.15em]"
              >
                <Phone size={16} /> {BUSINESS.phone}
              </a>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
};

export default Header;
